import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { PollApiCalls } from "../../apis/PollApiCalls";
import { UserApiCalls } from "../../apis/UserApiCalls";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import { usePPTWebView } from "../../hooks/usePPTWebView";
import {
    ACTIVITY_EDITOR_VIEW,
    AUDIENCE_RESTRICTION,
    HOME_PATH,
    POLL_SHARE_MODE,
    POLL_TITLE_LENGTH,
    POLL_TYPE,
    QUESTION_MAX_POINTS,
    QUESTION_TYPES,
    SYNC_LMS_OPTIONS,
    USER_SETTINGS
} from "../../utils/constants";
import {
    generateDefaultAttendanceTitle, generateDefaultPollTitle, getActivityAudienceRestriction,
    getDefaultUserSettings, getQuestionWeightage, getShortName, isShareByQuestionActivity,
    notifyError,
    removePrefix, removePrefixNew,
    transferUserSettings, updateCreateMode,
    validateText
} from "../../utils/helpers";
import {
    addQuestion,
    questionError,
    trimQuestion, trimLineBreakerInQuestion, setBlankRestriction
} from "../../utils/questionUtils";
import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import useNavigationGuard from "../../hooks/useNavigationGuard";
import classes from "../CreateQuizPage/ActivityEditor.module.css";
import ActivityEditorTitleContainer from "../CreateQuizPage/ActivityEditorTitleContainer";
import ActivityEditorDashboard from "../CreateQuizPage/ActivityEditorDashboard";
import ActivityEditorMainView from "../CreateQuizPage/ActivityEditorMainView";
import PPTActivitySaved from "./PPTActivitySaved";
import {PublicApiCall} from "../../apis/PublicApiCall";
import {CourseApiCalls} from "../../apis/CourseApiCalls";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import ActivityEditorImportQuestions from "../CreateQuizPage/ActivityEditorImportQuestions";


export default function PPTCreateActivityPage({}) {
    const { t } = useTranslation();
    const { pollType } = useParams();
    const {isFromSidebar, parseToken} = usePPTWebView();
    const [pollCode, setPollCode] = useState("");
    const [userSettings, setUserSettings] = useState(getDefaultUserSettings());
    const [currQueDisplay, setCurrQueDisplay] = useState(1);
    // const [description, setDescription] = useState("");
    const { saveAndPublish, softDeleteDraftPoll } = PollApiCalls();
    const {getCourseByUser} = CourseApiCalls();
    const { loadUser } = UserApiCalls();
    const {resolveShortName} = PublicApiCall();
    const {takeScreenshotsNew, warmUpBrowser} = ReportApiCalls();
    // const { getSetting } = InstitutionApiCalls();
    const history = useHistory();
    // const [pollTypeModalShow, setPollTypeModalShow] = useState(false);
    const location = useLocation();
    const {getDefaultConfiguration, correctConfigurations, verifyConfiguration, isLMS} = useSynLMSConfiguration();

    const [focusMCElem, setFocusMCElem] = useState(-1);
    const [focusSAElem, setFocusSAElem] = useState(-1);
    const [focusTFElem, setFocusTFElem] = useState(-1);
    const [focusFITBElem, setFocusFITBElem] = useState(-1);
    const [focusCIElem, setFocusCIElem] = useState(-1);
    const [focusMHElem, setFocusMHElem] = useState(-1);
    // const [focusWCElem, setFocusWCElem] = useState(-1);
    const [setSaveExit, getsaveExit] = useLocalStorageNew("saveExit", false);
    // const [setShowAnswer, getShowAnswer] = useLocalStorageNew("showAnswer", false);
    const [setRecentActivity, getRecentActivity] = useLocalStorageNew("recentActivity", {});
    const [setHostResource, getHostResource] = useLocalStorageNew(window.location.hostname, {});
    const [setTempPollKey, ] = useLocalStorageNew("activity_creation_temp_pollKey", "");


    const [dataLoading, setDataLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isAutoSaving, setIsAutoSaving] = useState(null);
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);

    const [savedActivity, setSavedActivity] = useState({});
    const [draftActivity, setDraftActivity] = useState({});
    const [editorView, setEditorView] = useState(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [courseList, setCourseList] = useState([]);
    const [hasClicked, setHasClicked] = useState(false);

    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        setDraftActivity(copy);
    }

    const {checkAnyQuestionIsLoading} = useImageLoaderManager(draftActivity.questions, setQuestions);


    const loadCourse = async () => {
        const {intType="", idpType=""} = parseToken();
        const courses = await getCourseByUser(idpType, intType);
        const options = courses.map(course => ({
            value: course.courseId,
            label: course.courseName,
            code: course.courseCode,
            isLmsCourse: !!course.index3Pk,
            lmsCourseId: removePrefixNew(!!course.index3Pk ? course.index3Pk : "")
        }));
        setCourseList(options);

        return options;
    }

    const initializeQuestions = () =>  {
        const {institutionId, userId} = parseToken();
        warmUpBrowser("", "", "").then();
        let promise1 = loadUser(institutionId, userId).then(res => {
            let { settings = {} } = res;
            return settings;
        }).catch(e => {
            console.log(e);
           return {};
        });


        let shortName = getShortName();
        let promise2 = resolveShortName(shortName).catch((e) => {
            console.log(e);
            return {};
        });

        let promise3 = loadCourse();

        Promise.all([promise1, promise2, promise3])
            .then(([settings, resource, courseOptions]) => {
                settings = transferUserSettings(settings);
                setUserSettings(settings);

                let hostResource = getHostResource();
                hostResource.shortName = resource.shortName;
                hostResource.fullName = resource.fullName;
                hostResource.institutionId = resource.institutionId;
                hostResource.bgImgLocation = resource.bgImgLocation;
                hostResource.imageURL = resource.imageURL;
                hostResource.logoImageURL = resource.logoImageURL;
                hostResource.ssoConfig = resource.ssoConfig;
                hostResource.platformSetting = resource.platformSetting;
                hostResource.evpVideoApiUrl = resource.evpVideoApiUrl;
                hostResource.privateEVPLink = resource.privateEVPLink;
                setHostResource(hostResource);


                const recentActivity = getRecentActivity();

                let activity = {};
                activity.pollKey = recentActivity.pollKey;
                activity.pollTitle = !!recentActivity.pollTitle ? recentActivity.pollTitle : generateDefaultTitle();
                activity.pollType = pollType;
                activity.gradeSchema = recentActivity.gradeSchema;
                activity.pollShareMode = POLL_SHARE_MODE.UNKNOWN;
                activity.pollDescription = recentActivity.pollDescription;
                activity.pollTimeLimit = recentActivity.hasOwnProperty("pollTimeLimit") ? recentActivity.pollTimeLimit : settings[USER_SETTINGS.POLL_DURATION];
                activity.pollBreakDuration = recentActivity.hasOwnProperty("pollBreakDuration") ? recentActivity.pollBreakDuration : settings[USER_SETTINGS.POLL_BREAK_DURATION];
                activity.getReadyAllTimeLimit = recentActivity.hasOwnProperty("getReadyAllTimeLimit") ? recentActivity.getReadyAllTimeLimit : settings[USER_SETTINGS.POLL_COUNTDOWN];
                activity.recordAttempt = recentActivity.hasOwnProperty("recordAttempt") ? recentActivity.recordAttempt : settings[USER_SETTINGS.POLL_RECORD_ATTEMPTS];
                activity.lmsAttempt = recentActivity.hasOwnProperty("lmsAttempt") ? recentActivity.lmsAttempt : settings[USER_SETTINGS.POLL_LMS_SYNC];
                activity.maxAttempts = recentActivity.hasOwnProperty("maxAttempts") ? recentActivity.maxAttempts : settings[USER_SETTINGS.POLL_MAX_ATTEMPTS];
                activity.showAnswerOnViewer = recentActivity.hasOwnProperty("showAnswerOnViewer") ? recentActivity.showAnswerOnViewer : settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS];
                activity.audienceRestriction = getActivityAudienceRestriction(recentActivity, settings);
                activity.pptAutoShare = recentActivity.hasOwnProperty("pptAutoShare") ? recentActivity.pptAutoShare : settings[USER_SETTINGS.PPT_AUTO_SHARE];
                activity.manualEnd = recentActivity.hasOwnProperty("manualEnd") ? recentActivity.manualEnd : settings[USER_SETTINGS.ATTENDANCE_MANUAL_END];
                activity.lmsRedirectUrl = recentActivity.lmsRedirectUrl;
                activity.D2LModuleId = recentActivity.D2LModuleId;
                activity.moodleSectionId = recentActivity.moodleSectionId;
                activity.courseId = removePrefix(recentActivity.courseId);

                if (recentActivity.hasOwnProperty("syncLms")) {
                    activity.syncLms = recentActivity.syncLms;
                    activity.syncLmsOption = recentActivity.syncLmsOption;
                }

                // if (recentActivity.hasOwnProperty("syncLms")) {
                //     activity.syncLms = recentActivity.syncLms;
                //     activity.syncLmsOption = recentActivity.syncLmsOption;
                //     activity.courseId = recentActivity.courseId;
                // } else {
                //     const {syncLms, syncLmsOption, courseId, audienceRestriction} = getDefaultConfiguration(courseOptions);
                //     activity.syncLms = syncLms;
                //     activity.syncLmsOption = syncLmsOption;
                //     activity.courseId = courseId;
                //     activity.audienceRestriction = !!audienceRestriction ? audienceRestriction : activity.audienceRestriction;
                // }


                if (activity.pollType === POLL_TYPE.ATTENDANCE) {
                    if (recentActivity.pollType !== POLL_TYPE.ATTENDANCE
                        || !recentActivity.hasOwnProperty("questions")
                        || recentActivity.questions.length !== 1
                        || recentActivity.questions[0].questionType !== QUESTION_TYPES.SA.name
                    ) {
                        const qs = addQuestion([], QUESTION_TYPES.SA.name, userSettings, false, POLL_TYPE.ATTENDANCE);
                        activity.questions = qs;
                    } else {
                        activity.questions = recentActivity.questions;
                    }

                    activity.geofence = recentActivity.hasOwnProperty("geofence") ? recentActivity.geofence : {};
                    activity.attendanceDuration = recentActivity.hasOwnProperty("attendanceDuration") ? recentActivity.attendanceDuration : settings[USER_SETTINGS.ATTENDANCE_DURATION];
                    setEditorView(isLMS()
                        ? (!!verifyConfiguration(activity) ? ACTIVITY_EDITOR_VIEW.OVERVIEW : ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING)
                        : ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING);
                    updateCreateMode(POLL_TYPE.MERGED_POLL);
                    if (!recentActivity.hasOwnProperty("syncLms") && !isLMS()) {
                        activity.syncLms = false;
                    }
                } else {
                    activity.questions = !!recentActivity.questions && !!recentActivity.questions.length ? JSON.parse(JSON.stringify(recentActivity.questions)) : [{serialNo: 1}];
                    setBlankRestriction(activity.questions);
                    setEditorView(!!activity.gradeSchema ? ACTIVITY_EDITOR_VIEW.QUESTION_EDITING : ACTIVITY_EDITOR_VIEW.OVERVIEW);
                }


                setSavedActivity(activity);
                setDraftActivity(JSON.parse(JSON.stringify(activity)));
                setCurrQueDisplay(1);
            }).finally(() => {
                setDataLoading(false);
            });
    };


    const hasUnsavedChanges = useMemo(
        () => JSON.stringify(draftActivity) !== JSON.stringify(savedActivity) && getsaveExit() !== true,
        [draftActivity, getsaveExit, savedActivity],
    );

    const {
        showConfirm: alertShow,
        confirmationModal: leaveConfirmationModal,
    } = useNavigationGuard({
        hasUnsavedChanges,
        onBypass: () => {
            setSaveExit(false);
            resetPoll();
        },
        onConfirm: () => {
            resetPoll();
        },
    });

    // useEffect(() => {
    //     if (questions.length < currQueDisplay) {
    //         return;
    //     }
    //
    //     switch(questions[currQueDisplay-1].questionType) {
    //         case QUESTION_TYPES.MCSS.name:
    //             if(focusMCElem !== -1) {
    //                 document.getElementsByName("question-text")[focusMCElem].focus();
    //                 setFocusMCElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.SA.name:
    //         case QUESTION_TYPES.IB.name:
    //         case QUESTION_TYPES.RETRO.name:
    //         case QUESTION_TYPES.BS.name:
    //             if(focusSAElem !== -1) {
    //                 document.getElementsByName("question-text")[focusSAElem].focus();
    //                 setFocusSAElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.TF.name:
    //             if(focusTFElem !== -1) {
    //                 document.getElementsByName("question-text")[focusTFElem].focus();
    //                 setFocusTFElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.FITB.name:
    //             if(focusFITBElem !== -1) {
    //                 if(focusFITBElem === 0) {
    //                     document.getElementsByClassName("notranslate public-DraftEditor-content")[focusFITBElem].focus();
    //                 } else {
    //                     document.getElementsByName("question-text")[focusFITBElem-1].focus();
    //                 }
    //                 setFocusFITBElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.CI.name:
    //             if(focusCIElem !== -1) {
    //                 document.getElementsByName("question-text")[focusCIElem].focus();
    //                 setFocusCIElem(-1);
    //             }
    //             break;
    //
    //         case QUESTION_TYPES.MH.name:
    //             if(focusMHElem !== -1) {
    //                 console.log(focusMHElem);
    //                 document.getElementsByName("question-text")[focusMHElem].focus();
    //                 setFocusMHElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.WC.name:
    //             // if(focusWCElem !== -1) {
    //             //   document.getElementsByClassName("poll-sub-text focus-outline-none")[focusWCElem].focus();
    //             //   setFocusWCElem(-1);
    //             // }
    //             break;
    //     }
    // }, [currQueDisplay, focusMCElem, focusSAElem, focusTFElem, focusFITBElem, focusCIElem, focusMHElem]);

    const validatePoll = (draft, focusError=true) => {
        if (!validateText(draft.pollTitle, POLL_TITLE_LENGTH)) {
            if (focusError) {
                notifyError(t("activity.titleError"));
                // document.getElementsByName("pollTitle")[0].focus();
            }
            return false;
        }

        if (draft.pollType !== POLL_TYPE.ATTENDANCE && !draft.hasOwnProperty("gradeSchema")) {
            notifyError(t("activity.typeMissingError"));
            setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW);
            return false;
        }

        if (draft.syncLmsOption !== SYNC_LMS_OPTIONS.EMBEDDED
            && draft.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED
            && !draft.courseId
        ) {
            setEditorView(ACTIVITY_EDITOR_VIEW.CONFIGURATION);
            notifyError(t("sharePoll.selectCourseMessage"));
            return false;
        }

        let i = 0;
        for (let q of draft.questions) {
            i++;
            if (getQuestionWeightage(q) > QUESTION_MAX_POINTS) {
                if (focusError) {
                    let errorWithQuestion = t("accessibility.questionPrefix") + " " + i + ": " + t("questionBuilder.maxPointsExceeded");
                    notifyError(errorWithQuestion);
                    setCurrQueDisplay(q.serialNo);
                    setEditorView(draft.pollType === POLL_TYPE.ATTENDANCE
                        ? ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING
                        : ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
                    );
                }
                return false;
            }
        }

        let index = 0;
        for (let q of draft.questions) {
            index++;
            if (focusError) setCurrQueDisplay(q.serialNo);
            let {quesError, elemIndex} = questionError(q, draft.pollType, draft.gradeSchema);
            switch(q.questionType) {
                case QUESTION_TYPES.MCSS.name:
                    if (focusError) setFocusMCElem(elemIndex);
                    break;
                case QUESTION_TYPES.SA.name:
                case QUESTION_TYPES.IB.name:
                case QUESTION_TYPES.RETRO.name:
                case QUESTION_TYPES.BS.name:
                    if (focusError) setFocusSAElem(elemIndex);
                    break;
                case QUESTION_TYPES.TF.name:
                    if (focusError) setFocusTFElem(elemIndex);
                    break;
                case QUESTION_TYPES.FITB.name:
                    if (focusError) {
                        setTimeout(() => {
                            setFocusFITBElem(elemIndex);
                        }, 100);
                    }
                    break;
                case QUESTION_TYPES.CI.name:
                    if (focusError) setFocusCIElem(elemIndex);
                    break;
                case QUESTION_TYPES.MH.name:
                    if (focusError) setFocusMHElem(elemIndex);
                    break;
                case QUESTION_TYPES.WC.name:
                    // setFocusWCElem(elemIndex);
                    break;
            }

            if (quesError) {
                if (focusError) {
                    let errorWithQuestion = t("accessibility.questionPrefix") + " " + index + ": " + quesError;
                    // setQuestions(chooseQuestion(q.serialNo, questions));
                    setCurrQueDisplay(q.serialNo);
                    setEditorView(draft.pollType === POLL_TYPE.ATTENDANCE
                        ? ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING
                        : ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
                    );
                    notifyError(errorWithQuestion);
                    return false;
                }
            }
        }
        return true;
    };


    const savePoll = async (updatedQuestions=[]) => {
        let generatedTitle = generateDefaultPollTitle();

        let pollToAdd = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = updatedQuestions && updatedQuestions.length > 0 ? JSON.parse(JSON.stringify(updatedQuestions)) : pollToAdd.questions;

        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }

        if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
            pollToAdd.questions = trimQuestion(questionsCopy, draftActivity.gradeSchema);
        }
        pollToAdd.pollTitle = !!pollToAdd.pollTitle ? pollToAdd.pollTitle : generatedTitle;
        pollToAdd = correctConfigurations(pollToAdd);


        let result = await saveAndPublish(pollToAdd, false);
        if (!result) {
            return false;
        }

        let {draft={}, uniqueCode, published={}} = result;
        published = !!published ? published : {};
        let pollKeyTemp = removePrefix(draft.pollKey);
        const {isValid, pk, sk, totalQuestions} = published;


        if (!!isValid) {
            takeScreenshotsNew(
                removePrefixNew(pk),
                removePrefixNew(sk),
                isShareByQuestionActivity(published),
                Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
            );
        }


        if (uniqueCode) {
            setPollCode(uniqueCode);
        }

        const copy = JSON.parse(JSON.stringify(draftActivity));
        if (pollToAdd.pollKey !== pollKeyTemp
            || pollToAdd.pollTitle !== draftActivity.pollTitle
            || (updatedQuestions && updatedQuestions.length > 0)
        ) {
            if (pollToAdd.pollKey !== pollKeyTemp) {
                copy.pollKey = pollKeyTemp;
            }

            if (pollToAdd.pollTitle !== draftActivity.pollTitle) {
                copy.pollTitle = pollToAdd.pollTitle;
            }

            if (updatedQuestions && updatedQuestions.length > 0) {
                copy.questions = updatedQuestions;
            }

            setDraftActivity(copy);
            setSavedActivity(JSON.parse(JSON.stringify(copy)))
        } else {
            setSavedActivity(copy)
        }


        window.onbeforeunload = undefined;
        return true;
    };

    const savePollClose = () => {
        let pollToAdd = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = pollToAdd.questions;

        if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
            questionsCopy = trimQuestion(questionsCopy, draftActivity.gradeSchema);
        }

        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }
        pollToAdd.questions = questionsCopy;
        pollToAdd = correctConfigurations(pollToAdd);

        if (!validatePoll(pollToAdd)) {
            return;
        }
        let error = verifyConfiguration(pollToAdd);
        if (!!error) {
            notifyError(error);
            setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW);
            return;
        }

        setIsSaving(true);

        saveAndPublish(pollToAdd).then((result) => {
            if (!result) {
                return;
            }

            let {draft = {}, uniqueCode, published={}} = result;
            published = !!published ? published : {};
            const {isValid, pk, sk, totalQuestions} = published;

            if (!!isValid) {
                takeScreenshotsNew(
                    removePrefixNew(pk),
                    removePrefixNew(sk),
                    isShareByQuestionActivity(published),
                    Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
                );
            }


            let pollKeyTemp = removePrefix(draft.pollKey);

            if (pollToAdd.pollKey !== pollKeyTemp) {
                pollToAdd.pollKey = pollKeyTemp;
            }

            pollToAdd.syncLms = draft.syncLms;
            pollToAdd.syncLmsOption = draft.syncLmsOption;
            pollToAdd.lmsHomeUrl = draft.lmsHomeUrl;
            pollToAdd.audienceRestriction = draft.audienceRestriction;
            pollToAdd.courseId = removePrefix(draft.courseId);

            setSavedActivity(pollToAdd);
            setDraftActivity(JSON.parse(JSON.stringify(pollToAdd)));

            setSaveExit(true);
            window.onbeforeunload = undefined;
            setPollCode(uniqueCode);
            setEditorView(ACTIVITY_EDITOR_VIEW.SAVE_SUCCESS);
        }).finally(() => {
            setIsSaving(false);
        });

        // goPollsPage();
    };


    useEffect(() => {
        return () => {
            window.onbeforeunload = undefined;
        };
    }, []);



    const resetPoll = () => {
        setIsSaving(false);
        setRecentActivity({});
        setTempPollKey("");
    }

    useEffect(() => {
        if (!!Object.entries(draftActivity).length) {
            setRecentActivity(draftActivity);
        }

        if (draftActivity.pollType === POLL_TYPE.MERGED_POLL) {
            if (!draftActivity.gradeSchema
                || !draftActivity.questions
                || !draftActivity.questions.length
                || !draftActivity.questions.filter(q => !!q.questionType).length
            ) {
                setSaveBtnDisabled(true);
            } else {
                setSaveBtnDisabled(false);
            }

        }
    }, [draftActivity]);

    useEffect(() => {
        let fromSidebar = isFromSidebar();
        // reset the local storage when click 'create poll/attendance' from the PPT plugin tool bar
        if (!fromSidebar) {
            resetPoll();
        }

        setDataLoading(true);
        initializeQuestions();
    }, [location]);



    // code that saves when refresh
    // useEffect(() => {
    //   const handleBeforeUnload = async () => {
    //       if (validateText(title, POLL_TITLE_LENGTH)) {
    //         await savePoll(false);
    //         setPollTitle(title);
    //         setQues(questions);
    //         setType(pollType);
    //     }
    //   };

    //   window.addEventListener('beforeunload', handleBeforeUnload);

    //   return () => {
    //     window.removeEventListener('beforeunload', handleBeforeUnload);
    //   };
    // }, [title, questions, pollType]);

    // Set the image url to an empty string for each question so that image load correctly
    // useEffect(() => {
    //     const handleBeforeUnload = async () => {
    //         const Local_questions = getQues();
    //         const updatedQuestions = Local_questions.map((question) => ({
    //             ...question,
    //             imgUrl: "",
    //         }));
    //         setQues(updatedQuestions)
    //     };
    //
    //     window.addEventListener('beforeunload', handleBeforeUnload);
    //
    //     return () => {
    //         window.removeEventListener('beforeunload', handleBeforeUnload);
    //     };
    // }, [title, questions, pollType]);


    useEffect(() => {
        if (!!alertShow || !!isSaving || !!showDeleteModal) {
            return;
        }
        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            return;
        }

        if (checkAnyQuestionIsLoading()) {
            return;
        }

        const interval = setInterval(() => {
            if (JSON.stringify(draftActivity) !== JSON.stringify(savedActivity)) {
                setIsAutoSaving(true);
                savePoll().finally(() => setIsAutoSaving(false));
            }
        }, 10000);
        return () => clearInterval(interval);
    }, [draftActivity, savedActivity, alertShow, showDeleteModal, isSaving]);


    const generateDefaultTitle = () => {
        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            return generateDefaultAttendanceTitle();
        } else {
            return generateDefaultPollTitle();
        }
    }


    const deletePollConfig = {
        title: t("poll.deleteActivityTitle"),
        okText: t("common.delete"),
        cancelText: t("common.cancel"),
        submit: () => {
            if (!draftActivity.pollKey) {
                resetPoll();
                if (history.length > 2) {
                    history.goBack();
                } else {
                    history.push(HOME_PATH);
                }
                return;
            }

            softDeleteDraftPoll(draftActivity.pollKey, draftActivity.pollType).then(() => {
                if (history.length > 2) {
                    history.goBack();
                } else {
                    history.push(HOME_PATH);
                }
            });
        },
        close: () => {
            setShowDeleteModal(false);
        },
    };


    if (editorView === ACTIVITY_EDITOR_VIEW.SAVE_SUCCESS) {
        return (
            <PPTActivitySaved
                pollKey={draftActivity?.pollKey}
                pollCode={pollCode}
                savedActivity={savedActivity}
            />
        );
    } else if (editorView === ACTIVITY_EDITOR_VIEW.IMPORT_QUESTIONS) {
        return (
            <ActivityEditorImportQuestions
                setEditorView={setEditorView}
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                courseList={courseList}
                userSettings={userSettings}
            />
        );
    }


    return (
        <>
            {leaveConfirmationModal}

            <YuJaGeneralAlert
                show={showDeleteModal}
                setModalShow={setShowDeleteModal}
                content={t("poll.deleteActivityModalBody")}
                config={deletePollConfig}
                AlertType={t("common.delete")}
            />

            <div className={`${classes.parentContainer} ${classes.gridLayout}`}>
                <ActivityEditorTitleContainer
                    dataLoading={dataLoading}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    userSettings={userSettings}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    isAutoSaving={isAutoSaving}
                    isSaving={isSaving}
                    handleSave={savePollClose}
                    setShowDeleteModal={setShowDeleteModal}
                    generateTitle={generateDefaultTitle}
                    saveBtnDisabled={isAutoSaving || isSaving || saveBtnDisabled}
                    editorView={editorView}
                    setEditorView={setEditorView}
                />

                <ActivityEditorDashboard
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setQuestions={setQuestions}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    userSettings={userSettings}
                />

                <ActivityEditorMainView
                    userSettings={userSettings}
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    savePoll={savePoll}
                    courseList={courseList}
                    setHasClicked={setHasClicked}
                    hasClicked={hasClicked}
                />
            </div>
        </>
    );
}